import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import ItemsFilter from '../../shared/components/items-filter';
import useProductPrice from '../../hooks/useProductPrice';

const selectPrices = (prices, products) => {
    return products.reduce((r, p, index) => {
        const { sku } = p;
        //return an empty price for sku so price count matches product list length
        if (sku && sku.indexOf('USER_DEFINED') > -1) {
            r[`UDF${index}`] = {};
        } else if (prices[sku]) {
            r[sku] = prices[sku];
        }

        return r;
    }, {});
};

const ProductFilter = React.memo(({ products, condition, deals, children }) => {
    const { prices: productPrices } = useProductPrice(products, { returnEmptyPriceObj: false });
    const prices = selectPrices(productPrices, products);
    const conditionParams = { prices, deals };
    const priceReady = Object.keys(prices).length === products.length;
    const checkCondition = useCallback(prd => condition(prd, conditionParams), [conditionParams]);
    return (
        <ItemsFilter items={products} condition={checkCondition} childProps={{ priceReady, checkCondition }}>
            {children}
        </ItemsFilter>
    );
});

const mapStateToProps = (state, ownProps) => {
    return {
        deals: state.deals,
    };
};

export default connect(mapStateToProps, null)(ProductFilter);
